"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionPlacement = exports.PositionType = void 0;
var PositionType;
(function (PositionType) {
    PositionType["Absolute"] = "u-pos-abs";
    PositionType["Fixed"] = "u-pos-fixed";
    PositionType["Relative"] = "u-pos-rel";
    PositionType["Static"] = "u-post-static";
})(PositionType = exports.PositionType || (exports.PositionType = {}));
var PositionPlacement;
(function (PositionPlacement) {
    PositionPlacement["Top"] = "u-pos-top-full";
    PositionPlacement["Right"] = "u-pos-right-full";
    PositionPlacement["Bottom"] = "u-pos-bottom-full";
    PositionPlacement["Left"] = "u-pos-left-full";
    PositionPlacement["TopLeft"] = "u-pos-top-left";
    PositionPlacement["TopRight"] = "u-pos-top-right";
    PositionPlacement["BottomLeft"] = "u-pos-bottom-left";
    PositionPlacement["BottomRight"] = "u-pos-bottom-right";
})(PositionPlacement = exports.PositionPlacement || (exports.PositionPlacement = {}));
//# sourceMappingURL=Position.js.map